import type { CallScoreResult } from './calculateCallScore';
import { sendAnalyticsInfo } from './sendAnalytics';

import type { WebRTCCallQualityAnalytics } from 'features/analytics/services/';

export const sendWebRTCCallScore = (
  peerId: string,
  score: CallScoreResult,
  dispatch: (action: any) => void,
  callId?: number
): void => {
  dispatch(
    sendAnalyticsInfo({
      Event: 'CallScore',
      Message: `Call quality score for peer ${peerId}`,
      Method: 'sendWebRTCCallScore',
      CallId: callId,
      CallScore: {
        peerId,
        timestamp: new Date().toISOString(),
        score: score.score,
        grade: score.grade,
        metrics: score.metrics,
        breakdown: score.breakdown,
      },
    })
  );
};

export const sendWebRTCMetrics = (
  globalAnalyticsInstance: WebRTCCallQualityAnalytics,
  dispatch: (action: any) => void
): void => {
  if (!globalAnalyticsInstance) {
    return;
  }

  const connections = globalAnalyticsInstance.getAllConnections();
  connections.forEach((peerId) => {
    const metrics = globalAnalyticsInstance?.getLatestConnectionMetrics(peerId);
    if (metrics) {
      dispatch(
        sendAnalyticsInfo({
          Event: 'WebRTCMetrics',
          Message: `Periodic WebRTC metrics for peer ${peerId}`,
          Method: 'WebRTCAnalytics',
          PeerId: peerId,
          Metrics: metrics,
          Timestamp: new Date().toISOString(),
        })
      );
    }
  });
};
